import React from 'react'
import Img from 'components/shared/Image/Img'
import Button from 'components/shared/Button'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const SocialsGridCard = ({ className, theme, icon, link }) => {
  return (
    <div className={cx(className, css.SocialsGridCard, theme)}>
      {icon && icon.media && (
        <div className={css.icon}>
          <div className={cx(css.iconBackground, theme)} />
          <Img className={css.img} {...icon} />
        </div>
      )}
      {link && (
        <Button
          className={css.button}
          buttonClassName={css.buttonLink}
          fullWidth
          theme={theme}
          {...link}
        />
      )}
    </div>
  )
}

SocialsGridCard.defaultProps = {}

export default SocialsGridCard
